import { parseDateSafe } from "./time.js";

// Live search matching, shared by the search overlay and the home page's bar.
//
// Both surfaces filter the same in-memory inventory and must agree on what
// matches and in what order — a term that surfaces a piece in one and not the
// other reads as a bug in whichever you tried second. Keeping the rules here
// is what stops them drifting.

/** How many matches a surface shows under its bar. */
export const HIT_COUNT = 8;

/**
 * How long a bar waits after the last keystroke before its matches change.
 * Results come from memory, so without this they rewrite on every character —
 * the list thrashes while you are still typing a word and settles on terms
 * you were only passing through.
 */
export const SETTLE_MS = 900;

export const listedAt = (item) => parseDateSafe(item?.created_at || item?.updated_at) ?? 0;

export const coverOf = (item) => {
  const photos = Array.isArray(item?.photos_json) ? item.photos_json : [];
  return photos[item?.cover_index || 0]?.url || photos[0]?.url || null;
};

// The catalog search's haystack (FeaturedPage), so a bar and the results page
// agree on what matches; scored so a title hit outranks a brand hit, which
// outranks a hit anywhere else.
export function matchScore(item, q) {
  const has = (v) => typeof v === "string" && v.toLowerCase().includes(q);
  if (has(item.title)) return 3;
  if (has(item.brand_name) || has(item.brand)) return 2;
  if ([item.category, item.style_code, item.sku, item.description, item.color].some(has)) return 1;
  return 0;
}

/** The best `limit` matches for an already-lowercased, trimmed `q`. */
export function rankHits(items, q, limit = HIT_COUNT) {
  if (!q || !items || !items.length) return [];
  return items
    .map((item) => ({ item, score: matchScore(item, q) }))
    .filter((h) => h.score > 0)
    // Newest first within a score, so equally-good matches lead with what
    // just landed.
    .sort((a, b) => b.score - a.score || listedAt(b.item) - listedAt(a.item))
    .slice(0, limit)
    .map((h) => h.item);
}
